import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { DatoCmsService } from "../../../services";
import { AutocompleteDefinition } from "./autocomplete-definition";
import { get } from "lodash";

export class SimpleAutocompleteSelection<K> {
  constructor(readonly cms: DatoCmsService, readonly autocompleteDef: AutocompleteDefinition<K>) {
  }

  hookToCMS(): Observable<any> {
    return this.cms.getPluginInitializer()
      .pipe(
        tap(plugin => {
          this.autocompleteDef.setMaximumNumberOfSelectedEntities(get(plugin, 'parameters.instance.maxNumberOfSelectedEntities'));
          const entity = plugin.getFieldValue(plugin.fieldPath);

          if (entity) {
            if (this.autocompleteDef.maximumNumberOfSelectedEntities === 1) {
              this.autocompleteDef.initialValues$
                .next(new Array<K>(JSON.parse(entity)));
            } else {
              this.autocompleteDef.initialValues$.next(JSON.parse(entity));
            }
          }
        })
      );
  }

  loadFromCMS() {
    this.hookToCMS().subscribe();
  }

  saveNewValue(value: Array<K>): void {
    this.cms.getPluginInitializer().subscribe(plugin => {
      if (value) {
        if (this.autocompleteDef.maximumNumberOfSelectedEntities === 1) {
          plugin.setFieldValue(plugin.fieldPath, JSON.stringify(value[0]));
        } else {
          plugin.setFieldValue(plugin.fieldPath, JSON.stringify(value));
        }
      } else {
        plugin.setFieldValue(plugin.fieldPath, null);
      }
    });
  }
}
